import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-cream" data-id="element-157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-lg border border-cream-dark text-center relative overflow-hidden" data-id="element-159">
          {/* Decorative background shield */}
          <ShieldCheck className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 text-cream opacity-50 pointer-events-none" data-id="element-160" />

          <div className="relative z-10" data-id="element-161">
            <div className="w-20 h-20 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-162">
              <ShieldCheck className="w-10 h-10 text-gold" data-id="element-163" />
            </div>

            <h2 className="text-3xl md:text-4xl font-display font-bold text-dark mb-6" data-id="element-164">
              🛡️ GARANTÍA DE 7 DÍAS — SIN PREGUNTAS
            </h2>

            <p className="text-lg md:text-xl text-dark-light leading-relaxed max-w-2xl mx-auto" data-id="element-165">
              Descargá el libro. Leé los primeros capítulos. Aplicá los
              ejercicios de los bonos. Y si sentís que no era lo que esperabas o
              que no te aporta valor, nos mandás un mail y te devolvemos el 100%
              de tu dinero.
              <br data-id="element-166" />
              <br data-id="element-167" />
              <strong className="text-dark" data-id="element-168">
                Sin vueltas, sin llamadas incómodas, ni formularios raros. El
                riesgo corre por nuestra cuenta.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}